import { Route as ShiftHistoryRoute } from "@/routes/(pharma)/_layout/reports/shift-history/index";
import { useQuery } from "@tanstack/react-query";
import { getShiftHistory } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useShiftHistoryData = () => {
  const searchParams = ShiftHistoryRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["shift-history", searchParams],
    queryFn: async () => {
      const response = await getShiftHistory(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.shifts,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};